import React from 'react';
import MaterialIcon from '../../MaterialIcon';

export default function MultiplePropertyContent(props) {
    return (
        <div className="filter-group">
            <div className="filter-group-header multiple-property">
                <div className="checkbox-wrapper">
                    {props.label}
                </div>
                <button className="add-new-property-button" onClick={() => props.onAddNew()}>
                    <MaterialIcon icon="add_circle"/>Add New
                </button>
            </div>
            {props.children &&
            <div className="filter-group-content">
                {props.children}
            </div>
            }
        </div>
    );
}